module.exports = __webpack_public_path__ + "img/inflcosmall.7042a855.png";